import React, { useState, useEffect } from "react";
import { Col, Row, Form, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// component
import BranchShopLogo from "./component/branch_shop_logo";
import BranchShopName from "./component/branch_shop_name";
import BranchShopId from "./component/branch_shop_id";
import BranchShopPhone from "./component/branch_shop_phone";
import BranchShopEmail from "./component/branch_shop_email";
import BranchShopAddress from "./component/branch_shop_address";
import BranchShopAdressSuburb from "./component/branch_shop_address_suburb";
import BranchShopAdressCity from "./component/branch_shop_address_city";
import BranchShopAdressState from "./component/branch_shop_address_state";
import BranchShopAdressPostCode from "./component/branch_shop_address_post_code";
// redux
import { updateBranch } from "../../store/branch/branch.action";
import { detailSelector } from "../../store/branch/branch.selector";

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 18,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 6,
    offset: 0,
  },
};

const BranchShopEdit = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "branch" });
  // -------------------------- STATE --------------------------
  const [logo, setLogo] = useState("");
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailSelector);
  console.log("branch", branch);
  // -------------------------- FUNCTION --------------------------

  const resetData = (branch, form) => {
    const values = {
      logo: branch?.logo || "",
      name: branch?.name || "",
      shopId: branch?.shopId || "",
      phone: branch?.phone || "",
      email: branch?.email || "",
      address: branch?.address || "",
      postCode: branch?.postCode || "",
      state: branch?.state || "",
      subUrb: branch?.subUrb || "",
      city: branch?.city || "",
    };
    setLogo(branch?.logo);
    form.setFieldsValue(values);
  };

  const onSelectLogo = (uri) => {
    setLogo(uri);
    form.setFieldsValue({ logo: uri });
  };

  const onSelectAddress = (values) => {
    form.setFieldsValue(values);
  };

  const handleEdit = () => {
    resetData(branch, form);
    setEdit(true);
  };

  const handleCancel = () => {
    resetData(branch, form);
    setEdit(false);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branch) {
      setEdit(false);
      resetData(branch, form);
    }
  }, [branch, form]);
  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    setLoading(true);
    const update = {
      ...values,
      logo: logo,
    };
    // console.log("update", update);
    dispatch(
      updateBranch({ branch, update }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update Shop Successfully!");
          setEdit(false);
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const onFinishFailed = (error) => {
    console.log({ error });
  };

  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    const disabled = loading || !edit;
    return (
      <Form
        name="edit_form"
        autoComplete="off"
        form={form}
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BranchShopLogo
              disabled={disabled}
              logo={logo}
              onSelect={onSelectLogo}
            />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopId disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopPhone disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopEmail disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={24}>
            <BranchShopAddress disabled={disabled} onSelect={onSelectAddress} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressSuburb disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressCity disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressState disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressPostCode disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderEditButton()}
            {renderSaveButton()}
          </Col>
        </Row>
      </Form>
    );
  };

  const renderEditButton = () => {
    if (!edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              type="primary"
              className="login-form-button form-button"
              loading={loading}
              onClick={() => handleEdit()}
              disabled={disabled}
            >
              {t("edit")}
            </Button>
          </Col>
        </Row>
      );
    }
    return null;
  };

  const renderSaveButton = () => {
    if (edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              className="login-form-button form-button"
              disabled={loading}
              onClick={() => handleCancel()}
            >
              {t("cancel")}
            </Button>
          </Col>
          <Col>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button form-button save"
                loading={loading}
              >
                {t("save")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      );
    }
    return null;
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderForm()}
      </Col>
    </Row>
  );
};

export default BranchShopEdit;
